import { config } from '@/kernel/config';

import { doPayloadRequest } from '@/kernel/api';
import { getOrganisationId, getOrganisationName } from '@/kernel/session';
import { getCollection } from '@/kernel/collections';

export const dehydrateCollections = (collectionMap, data) => {
  const dehydrated = {};

  collectionMap.forEach((pair) => {
    const collection = getCollection(pair.collection);

    if (Array.isArray(data[pair.key])) {
      dehydrated[pair.key] = data[pair.key].map((item) => {
        return collection.getId(item);
      });
    } else if (data[pair.key] !== null) {
      dehydrated[pair.key] = collection.getId(data[pair.key]);
    } else {
      dehydrated[pair.key] = null;
    }
  });

  return dehydrated;
}

export const rehydrateCollections = async (collectionMap, data) => {
  const rehydrated = {};

  await Promise.all(collectionMap.map(async (pair) => {
    const collection = getCollection(pair.collection);

    if (Array.isArray(data[pair.key])) {
      if (!data[pair.key].length) {
        rehydrated[pair.key] = [];
      } else {
        const items = await doPayloadRequest('GET', collection.getApiIndexEndpoint(), {
          params: {
            where: {
              id: {in: data[pair.key]}
            }
          }
        });

        rehydrated[pair.key] = items.docs;
      }
    } else if (data[pair.key] !== null) {
      rehydrated[pair.key] = await doPayloadRequest('GET', collection.getApiObjectEndpoint(data[pair.key]));
    } else {
      rehydrated[pair.key] = null;
    }
  }));

  return rehydrated;
}

export const formatDate = (date) => {
  return (new Date(date)).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export const getPDFExportUrl = (url) => {
  const organisationId = getOrganisationId();
  const urlObj = new URL(url, window.location.href);

  if (organisationId) {
    urlObj.searchParams.set('organisationId', organisationId);
  }

  return `${config.payloadApiEndpoint}/pdf?url=${encodeURIComponent(urlObj.toString())}`;
}

export const getReportPDFExportUrl = () => {
  return getPDFExportUrl(window.location.href.replace('/report', '/export'));
}

export const getExportTitle = (title, date = null) => {
  if (!date) {
    date = new Date();
  } else {
    date = new Date(date);
  }

  date = date.toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return `Jana Stewardship Tool - ${title} - ${date}`;
}

export const getExportOrganisation = () => {
  return getOrganisationName() || 'Jana Stewardship';
}

